import { createAction } from 'typesafe-actions';
import { Variant } from '../utils/types';

export const VARIANT_ITEM_CLICK = createAction('ui/VARIANT_ITEM_CLICK')<Variant>();

export const VARIANT_MORE_BUTTON_CLICK = createAction('ui/VARIANT_MORE_BUTTON_CLICK')<{
  extraVariantsToShow: number;
  axisTitle: string;
}>();
